import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MatDialog,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {
  ManagementAdminProfileComponent
} from '../../dialogs/admin-profile-dialog/admin-profile-dialog.component'

@Component({
  selector: 'foa-warning',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './warning.component.html'
})
export class WarningComponent {
  private readonly dialog = inject(MatDialog)

  public edit() {
    this.dialog.closeAll()
    this.dialog.open(ManagementAdminProfileComponent, {})
  }
}
